export default __webpack_public_path__ + "static/media/karkina_pudi.2c8045ac.png";